module.exports = __webpack_public_path__ + "static/img/vidPoster.84f155f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vidPoster.png
// module id = UQEN
// module chunks = 1